module.exports = __webpack_public_path__ + "img/k04.c591ef5b.png";